import type { SVGProps } from "react"
const Language = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M8 3.5a1 1 0 0 1 1 1V5h3a1 1 0 1 1 0 2h-.627c-.313 1.912-.929 3.524-1.936 4.819.752.525 1.675.928 2.806 1.21a1 1 0 1 1-.486 1.941c-1.461-.365-2.717-.928-3.757-1.725-1.04.797-2.296 1.36-3.757 1.725a1 1 0 1 1-.486-1.94c1.131-.283 2.054-.686 2.806-1.211C5.556 10.524 4.94 8.912 4.628 7H4a1 1 0 0 1 0-2h3v-.5a1 1 0 0 1 1-1ZM9.342 7C9.076 8.414 8.626 9.527 8 10.401 7.374 9.527 6.924 8.414 6.658 7h2.684Zm8.552 3.553a1 1 0 0 0-1.788 0l-4 8a1 1 0 1 0 1.788.894L14.618 18h4.764l.724 1.447a1 1 0 1 0 1.788-.894l-4-8ZM17 13.236 18.382 16h-2.764L17 13.236Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Language
